import { ValueEncoder } from "DiscoveryEngine.TS/Utils/ValueEncoder";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";

export class DiscoverySubtaskHandle implements ObjectSerializer {

    // Unique generation ID
    public GenerationId: number;
    // Unique subtask ID
    public SubtaskId: number;

    constructor(generationId?: number, subtaskId?: number) {
        this.Clear();

        if (generationId !== undefined)
            this.GenerationId = generationId;

        if (subtaskId !== undefined)
            this.SubtaskId = subtaskId;
    }

    public get HasGenerationId(): boolean {
        return (this.GenerationId >= 0);
    }

    public get HasSubtaskId(): boolean {
        return (this.SubtaskId >= 0);
    }

    public get IsValid(): boolean {
        return (this.HasGenerationId && this.HasSubtaskId);
    }

    public Clear(): void {
        this.GenerationId = -1;
        this.SubtaskId = -1;
    }

    public Equals(other: DiscoverySubtaskHandle): boolean {
        if (other == null)
            return false;
        return (this.GenerationId === other.GenerationId &&
            this.SubtaskId === other.SubtaskId);
    }

    public toString(): string {
        return "DiscoverySubtaskHandle(" + this.GenerationId + ", " + this.SubtaskId + ")";
    }

    public Write(obj: any, context: any): void {
        obj.discovery_subtask_handle = {};
        obj = obj.discovery_subtask_handle;

        obj.generation_id = ValueEncoder.EncodeInteger(this.GenerationId);
        obj.subtask_id = ValueEncoder.EncodeInteger(this.SubtaskId);
    }

    public Read(obj: any, context: any): void {
        this.Clear();

        if (!obj.discovery_subtask_handle) {
            throw new Error();
        }
        obj = obj.discovery_subtask_handle;

        if (obj.generation_id !== undefined)
            this.GenerationId = ValueEncoder.DecodeInteger(obj.generation_id);

        if (obj.subtask_id !== undefined)
            this.SubtaskId = ValueEncoder.DecodeInteger(obj.subtask_id);
    }

}
